export default {
  en: {
    messages: {
      '1stinitialquarter': '1st initial quarter',
      '1stinitialtracking': '1st initial tracking',
      '2ndand3rdquarter': '2nd and 3rd quarter',
      'cardiotoco': 'cardiotocography',
      anErrorHasOccurred: 'an error has occurred',
      changeMotherBirthdate: 'Mother\'s date of birth is different from the date given on the day of the exam ({birthdate}). Do you want to update the exam date?',
      confirmRemoveForm: 'Do you really want to remove the form',
      birthdate: 'birthdate',
      gestationalAge: 'Informations',
      invalidEmailOrPassword: 'invalid email or password',
      lastStudy: 'last study',
      newStudy: 'new study',
      newForm: 'new form',
      newGestation: 'new gestation',
      noMediaFound: 'no media found',
      noDoctor: 'No doctor assigned',
      obstetricdoppler: 'obstetric doppler',
      patientsNameAndPatID: 'patients name and patID',
      predictionOfLabor: 'prediction of labor',
      saveAndStartAttendance: 'save and start attendance',
      savedSuccessfully: 'saved successfully',
      startOfEvaluation: 'start of evaluation',
      studyDate: 'study date',
      successfullyRemoved: 'successfully removed',
      unamed: 'unamed',
      reportNotPublished: 'This report has not been published yet. Please wait for publication by the responsible physician.'
    },
    words: {
      action: 'action | actions',
      and: 'and',
      amniocentesis: 'amniocentesis',
      anamnese: 'anamnese',
      breasts: 'breasts',
      calculating: 'calculating',
      calculationFailure: 'calculationFailure',
      cancel: 'cancel',
      removePatient: 'remove Patient',
      cardiotocography: 'cardiotocography',
      riskprematurebirth: 'Risk premature birth',
      gynecologic: 'Gynecologic',
      comments: 'comments',
      conclusion: 'conclusion',
      observations: 'Observations',
      cordocentesis: 'cordocentesis',
      day: 'day',
      devices: 'devices',
      edit: 'edit',
      fetoscopy: 'fetoscopy',
      form: 'form',
      forms: 'forms',
      gestation: 'gestation',
      gestations: 'gestations',
      gynecological: 'gynecological',
      historic: 'historic',
      home: 'home',
      identity: 'identity',
      information: 'information',
      informations: 'informations',
      laser: 'laser',
      loading: 'loading',
      login: 'login',
      logout: 'logout',
      media: 'media',
      medias: 'medias',
      midia: 'midia',
      morphological: 'morphological',
      name: 'name',
      new: 'new',
      notes: 'notes',
      obstetricdoppler: 'obstetricdoppler',
      others: 'others',
      ovarians: 'ovarians',
      patient: 'patient | patients',
      print: 'print',
      profile: 'profile',
      company: 'company',
      companies: 'companies',
      report: 'report',
      save: 'save',
      search: 'search',
      schedule: 'schedule',
      studies: 'appointments',
      study: 'appointment',
      summary: 'summary',
      videos: 'videos',
      week: 'week | weeks',
      welcome: 'welcome',
      year: 'year | years',
      users: 'users',
      remoteSupport: 'Download Remote Support'
    }
  },
  'pt-BR': {
    messages: {
      '1stinitialquarter': '1º trimestre inicial',
      '1stinitialtracking': '1º trimestre rastreio',
      '2ndand3rdquarter': '2º e 3º trimestre',
      'cardiotoco': 'Cardiotocografia',
      riskprematurebirth: 'Avaliação do colo uterino',
      fetalBiophysicalProfile: 'Perfil Biofísico Fetal',
      gynecologic: 'Ginecológico',
      anErrorHasOccurred: 'ocorreu um erro',
      birthdate: 'data de nascimento',
      changeMotherBirthdate: 'Data de nascimento da mãe está diferente da data informada no dia do exame ({birthdate}). Deseja atualizar a data informada no exame?',
      confirmRemoveForm: 'Deseja realmente remover o formulário',
      gestationalAge: 'Informações',
      invalidEmailOrPassword: 'email ou senha não válidos',
      lastStudy: 'último exame',
      newStudy: 'Caso Corrente',
      newForm: 'Novo exame',
      newGestation: 'Novo Caso',
      noMediaFound: 'nenhuma mídia foi encontrada',
      noDoctor: 'Sem médico definido',
      obstetricdoppler: 'doppler obstétrico',
      patientsNameAndPatID: 'nome do paciente e patID',
      predictionOfLabor: 'previsão do parto',
      saveAndStartAttendance: 'salvar e iniciar atendimento',
      savedSuccessfully: 'salvo com sucesso',
      startOfEvaluation: 'início do caso.',
      studyDate: 'data do exame',
      successfullyRemoved: 'removido com sucesso',
      examemama: 'exame de mama',
      unamed: 'sem nome',
      ecocardiogramafetal: 'Ecocardiograma Fetal',
      reportNotPublished: 'Este laudo ainda não foi publicado. Por favor, aguarde a publicação pelo médico responsável.'
    },
    words: {
      action: 'ação | ações',
      and: 'e',
      amniocentesis: 'amniocentese',
      anamnese: 'anamnese',
      breasts: 'mamas',
      calculating: 'calculando',
      calculationFailure: 'falha no cálculo',
      cancel: 'cancelar',
      removePatient: 'remover Paciente',
      cardiotocography: 'cardiotocografia',
      riskprematurebirth: 'Avaliação do colo uterino',
      fetalBiophysicalProfile: 'Perfil Biofísico Fetal',
      gynecologic: 'Ginecológico',
      comments: 'observações',
      conclusion: 'conclusão',
      observations: 'Observações',
      cordocentesis: 'cordocentese',
      day: 'dia | dias',
      devices: 'dispositivos',
      edit: 'editar',
      fetoscopy: 'fetoscopia',
      form: 'formulário',
      forms: 'formulários',
      gestation: 'gestação',
      gestations: 'gestações',
      gynecological: 'ginecológico',
      historic: 'histórico',
      home: 'home',
      identity: 'cpf',
      information: 'informação',
      informations: 'informações',
      laser: 'laser',
      loading: 'carregando',
      login: 'entrar',
      logout: 'sair',
      media: 'mídia',
      medias: 'mídias',
      midia: 'midia',
      morphological: 'morfológico',
      name: 'nome',
      new: 'novo',
      notes: 'anotações',
      obstetricdoppler: 'doppler',
      others: 'outros',
      ovarians: 'ovários',
      patient: 'paciente | pacientes',
      print: 'impressão',
      profile: 'perfil',
      company: 'Empresa',
      companies: 'Empresas',
      report: 'Laudo',
      save: 'salvar',
      search: 'procurar',
      schedule: 'agendamento',
      studies: 'atendimentos',
      study: 'atendimento',
      summary: 'Resumo',
      videos: 'vídeos',
      week: 'semana | semanas',
      welcome: 'bem-vindo',
      year: 'ano | anos',
      users: 'usuários',
      remoteSupport: 'Baixar Suporte Remoto',
      examemama: 'exame de mama',
      composicaoMamaria: 'Composição mamária',
      Nodulos: 'Nodulos',
      ecocardiogramafetal: 'Ecocardiograma Fetal'
    }
  },
  es: {
    messages: {
      '1stinitialquarter': '1er trimestre inicial',
      '1stinitialtracking': '1er seguimiento inicial',
      '2ndand3rdquarter': '2do y 3er cuarto',
      'cardiotoco': 'cardiotocografía',
      anErrorHasOccurred: 'Se ha producido un error',
      changeMotherBirthdate: 'La fecha de nacimiento de la madre es diferente de la fecha dada el día del examen ({birthdate}). ¿Quieres actualizar la fecha del examen?',
      confirmRemoveForm: '¿Realmente quieres eliminar el formulario',
      birthdate: 'Fecha de nacimiento',
      gestationalAge: 'Informaciones',
      invalidEmailOrPassword: 'correo electrónico o contraseña inválida',
      lastStudy: 'ultimo estudio',
      newStudy: 'nuevo estudio',
      newForm: 'nuevo form',
      newGestation: 'nueva gestación',
      noMediaFound: 'No se encontraron medios',
      noDoctor: 'Sin médico asignado',
      obstetricdoppler: 'Doppler obstétrico',
      patientsNameAndPatID: 'nombre del paciente y patid',
      predictionOfLabor: 'predicción del parto',
      saveAndStartAttendance: 'guardar y comenzar la asistencia',
      savedSuccessfully: 'Guardado exitosamente',
      startOfEvaluation: 'comienzo de la evaluación',
      studyDate: 'fecha de estudio',
      successfullyRemoved: 'eliminado con éxito',
      unamed: 'sin nombre',
      reportNotPublished: 'Este informe aún no ha sido publicado. Por favor, espere la publicación por el médico responsable.'
    },
    words: {
      action: 'acción | acciones',
      and: 'y',
      amniocentesis: 'amniocentesis',
      anamnese: 'anamnesa',
      breasts: 'los pechos',
      calculating: 'calculador',
      calculationFailure: 'cálculoFailure',
      cancel: 'cancelar',
      removePatient: 'remover Paciente',
      cardiotocography: 'cardiotocografía',
      comments: 'comentarios',
      conclusion: 'conclusión',
      observations: 'Observaciones',
      cordocentesis: 'cordocentesis',
      day: 'día',
      devices: 'dispositivos',
      edit: 'editar',
      fetoscopy: 'fetoscopia',
      form: 'formar',
      forms: 'formas',
      gestation: 'gestación',
      gestations: 'gestaciones',
      gynecological: 'ginecológico',
      historic: 'histórico',
      home: 'casa',
      identity: 'identidad',
      information: 'información',
      informations: 'informaciones',
      laser: 'láser',
      loading: 'cargando',
      login: 'iniciar sesión',
      logout: 'cerrar sesión',
      media: 'medios de comunicación',
      medias: 'medias',
      midia: 'midia',
      morphological: 'morfologico',
      name: 'nombre',
      new: 'nuevo',
      notes: 'notas',
      obstetricdoppler: 'doppler obstétrico',
      others: 'otros',
      ovarians: 'ovarios',
      patient: 'paciente | pacientes',
      print: 'impresión',
      profile: 'perfil',
      company: 'empresa',
      companies: 'empresas',
      report: 'informe',
      save: 'salvar',
      search: 'buscar',
      schedule: 'cronograma',
      studies: 'citas',
      study: 'cita',
      summary: 'resumen',
      week: 'semana | semanas',
      welcome: 'Bienvenido',
      videos: 'videos',
      year: 'año | años',
      users: 'users',
      remoteSupport: 'Descargar Suporte Remoto'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/messages.js